module.exports = __webpack_public_path__ + "static/media/logogv.e8a3106a.png";